<button [appTooltip]="'app.navigation.theme.tooltip' | translate" (click)="switchTheme()"
  class="rounded-lg p-2 flex items-center justify-center active transition-all relative group/notificationButton">
  <app-svg-images [svgName]="(isDarkMode$ | async) ? 'moon-solid' : 'sun-solid'"
    class="h-6 inline-block transition-all group-hover/notificationButton:rotate-12 dark:text-amber-400 text-yellow-500"></app-svg-images>
</button>
